import { useMobileDetect } from "hooks/useMobileDetect";
import { User } from "models/User";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AppDispatch, RootState } from "store";
import { fetchBatchDetails, updateLiveStreamSettings } from "store/reducers/livestreamSettings";
import { useOpenInApp } from "utils/useOpenInApp";
const SessionDetailsCard = () => {
  const { isAndroid, isIOS } = useOpenInApp();
  const { batchDetails } = useSelector((state: RootState) => state.live.settings);
  const userState = useSelector((state: RootState) => state.auth.user as User);
  console.log("userState", userState);
  const token = useSelector((state: RootState) => state.auth?.token?.accessToken);
  const { isLoading } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const queryParams = new URLSearchParams(location.search);
  const batchId = queryParams.get("batchId");
  const isMobile = useSelector((state: RootState) => state.live.settings.isMobile)
  const trainingMinutes = Math.round(Number(batchDetails?.program?.training_hours) * 60);
  const isMobileBrowser = isAndroid || isIOS;
  console.log("isMobile", isMobile);

  useEffect(() => {
    if (batchId) {
      dispatch(fetchBatchDetails({ batchId }));
    }
  }, [batchId]);

  // const joinLiveSession = (id) => {
  //   dispatch(dispatch(updateLiveStreamSettings({ sessionLiveFlag: true })));
  //   const url = `https://learner-live-v3.viliyo.com/live/${id}`;
  //   window.open(url, "_self");
  // }
  const joinLiveSession = (sessionId: number) => {
    dispatch(updateLiveStreamSettings({ sessionLiveFlag: true }));
    
    // const baseUrl = `https://learner-live-v3.viliyo.com/live/${sessionId}`;
    const baseUrl = `https://learnerlive.viliyo.com/live/${sessionId}`;

    const url = `${baseUrl}?userid=${userState?.id}&token=${token}`;

    window.open(url, "_self");
  };

  // const joinLiveSession = (sessionId: number) => {
    // const baseUrl = `https://learner-live-v3.viliyo.com/live/${sessionId}`;
  //   const baseUrl = `https://learnerlive.viliyo.com/live/${sessionId}`;
  //   // const baseUrl = `http://localhost:5173/live/${sessionId}`;


  //   const url = isMobile
  //     ? `${baseUrl}?mobile=true&userid=${userState?.id}&token=${token}`
  //     : `${baseUrl}?userid=${userState?.id}&token=${token}`;

  //   // const url = `${baseUrl}?mobile=true&userid=${userState?.id}&token=${token}`;

  //   window.location.href = url;
  // };


  if (!batchDetails?.program || !batchDetails?.batch || !batchDetails?.sessions || isLoading) {
    return (
      <div
        className="flex justify-center items-center h-screen bg-[#2D3037] px-4"
        style={{
          // backgroundImage: `url('/img/joinSessionBackground.png')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="text-white text-lg">Loading session details...</div>
      </div>
    );
  }

  // const isJoinableNow = (startDate: string, startTime: string, endTime: string) => {
  //   const now = new Date();
  //   const [startHour, startMinute] = startTime.split(":").map(Number);
  //   const [endHour, endMinute] = endTime.split(":").map(Number);

  //   const startDateTime = new Date(startDate);
  //   startDateTime.setHours(startHour, startMinute, 0, 0);

  //   const endDateTime = new Date(startDate);
  //   endDateTime.setHours(endHour, endMinute, 0, 0);

  //   return now >= startDateTime && now <= endDateTime;
  // };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#2D3037] px-3 sm:px-4 text-white overflow-y-auto">

      <div className="w-full max-w-4xl flex flex-col items-center">

        <h1 className="text-center text-xl sm:text-[28px] font-light mb-4 text-gray-200">
          Welcome{" "}
          <span className="font-semibold text-white">
            {userState?.name}
          </span>
        </h1>

        <div className="w-full bg-[#2A2A2A] rounded-2xl p-4 sm:p-6 shadow-2xl">

          {/* PROGRAM DETAILS */}
          <div className="flex flex-col gap-4">

            <div className="flex flex-wrap gap-3 sm:gap-4">

              <div className="flex items-center bg-[#35363C] text-white rounded-full px-4 sm:px-5 py-3 w-full sm:w-[48%]">
                <span className="font-light text-xs whitespace-nowrap">Programme:</span>
                <div className="h-5 border-l border-[#D9D9D9] mx-3 sm:mx-4"></div>
                <span className="font-normal text-sm truncate">
                  {batchDetails?.program?.program_name}
                </span>
              </div>

              <div className="flex items-center bg-[#35363C] text-white rounded-full px-4 sm:px-5 py-3 w-full sm:w-[48%]">
                <span className="font-light text-xs whitespace-nowrap">Total Duration</span>
                <div className="h-5 border-l border-[#D9D9D9] mx-3 sm:mx-4"></div>
                <span className="font-normal text-sm">
                  {trainingMinutes || batchDetails?.program?.training_hours} mins
                </span>
              </div>

            </div>

            <div className="flex flex-wrap">
              <div className="flex items-center bg-[#35363C] text-white rounded-full px-4 sm:px-5 py-3 text-sm w-full sm:w-[48%]">
                <span className="font-light text-xs whitespace-nowrap">Batch:</span>
                <div className="h-5 border-l border-[#D9D9D9] mx-3 sm:mx-4"></div>
                <span className="font-normal text-sm truncate">
                  {batchDetails?.batch?.batch_name}
                </span>
              </div>
            </div>
          </div>

          {/* SESSION HEADER */}
          <div className="mt-6 sm:mt-8 mb-3">
            <p className="text-sm sm:text-base font-light text-white">Session(s)</p>
            <div className="border border-white mt-2"></div>
          </div>

          {/* SESSION LIST */}
          <div className="space-y-3 max-h-[320px] overflow-y-auto pr-1">
            {batchDetails?.sessions?.map((session, index) => {
              const canJoin = true;
              return (
                <div
                  key={index}
                  className="bg-[#35363C] text-white rounded-lg px-4 sm:px-6 py-4 flex flex-wrap items-center gap-3"
                >
                  <div className="flex-1 min-w-[120px]">
                    <p className="font-light text-xs text-gray-300">Session:</p>
                    <p className="font-normal text-xs truncate">
                      {session?.session_name}
                    </p>
                  </div>

                  <div className="hidden sm:block h-8 border-l border-[#D9D9D9] mx-2 sm:mx-6"></div>

                  <div className="flex items-center gap-4 sm:gap-8 flex-wrap">

                    <div>
                      <p className="font-light text-xs text-gray-300">Date:</p>
                      <p className="font-normal text-xs">
                        {session?.session_start_date}
                      </p>
                    </div>

                    <div>
                      <p className="font-light text-xs text-gray-300">Time:</p>
                      <p className="font-normal text-xs">
                        {session?.session_start_time} - {session?.session_end_time}
                      </p>
                    </div>

                    <button
                      disabled={!canJoin}
                      onClick={() => joinLiveSession(session?.sessionMappingId)}
                      className={`px-6 sm:px-8 py-2 rounded-full text-xs font-semibold tracking-wide transition-all duration-200 ${canJoin
                        ? "border border-green-400 text-white shadow-[0_0_10px_rgba(34,197,94,0.6)]"
                        : "bg-[#3B3D45] text-gray-500 cursor-not-allowed"
                        }`}
                    >
                      JOIN
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          {/* DOWNLOAD SECTION */}
          {isMobileBrowser && (
            <div className="mt-6 bg-[#35363C] rounded-xl p-4 flex flex-col items-center gap-3 text-center">

              <p className="text-sm text-gray-300">
                Get a better experience on the Viliyo mobile app
              </p>

              <div className="flex flex-wrap justify-center gap-4 mt-2">

                {isAndroid && (
                  <a
                    href="https://play.google.com/store/apps/details?id=com.viliyo"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/play_store.png"
                      alt="Download on Play Store"
                      className="h-10 object-contain"
                    />
                  </a>
                )}

                {isIOS && (
                  <a
                    href="https://apps.apple.com/us/app/viliyo/id6758509903"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/app_store.jpg"
                      alt="Download on App Store"
                      className="h-10 object-contain"
                    />
                  </a>
                )}
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default SessionDetailsCard;
